import * as utils from '../functions/utils';

interface InputObject {
  Answer?: string;
  Question?: string;
}

export default class QuestionAnswerModel {
  answer: string;
  question: string;

  constructor() {
    this.answer = '';
    this.question = '';
  }

  static mappingPropertyObject(_obj: InputObject): QuestionAnswerModel {
    let obj = new QuestionAnswerModel();
    obj.answer = _obj.Answer || '';
    obj.question = _obj.Question || '';
    obj = utils.cleanObjectKeys(Object.keys(new QuestionAnswerModel()), obj);

    return obj;
  }

  static mappingPropertyObjects(_objects: InputObject[]): QuestionAnswerModel[] {
    const results: QuestionAnswerModel[] = [];
    _objects.forEach(_item => {
      const item = QuestionAnswerModel.mappingPropertyObject(_item);
      results.push(item);
    });
    return results;
  }
}
